import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
`;

export const ImagesRow = styled.div`
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
	align-items: center;
`;

export const ImagePreview = styled.img`
	width: 100px;
	height: 100px;
	object-fit: cover;
	border-radius: 4px;
	cursor: pointer;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.8;
	}
`;

export const DropzoneContainer = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 200px;
	height: 100px;
	border: 2px dashed ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.lightGrey4)};
	background: ${({ theme, isPunchup }) => (isPunchup ? '#fafafa' : theme.colors.blackGrey3)};
	border-radius: 4px;
	cursor: pointer;
	transition: all 0.3s ease;

	&:hover {
		border-color: ${({ isPunchup }) => (isPunchup ? '#fe5e25' : '#666')};
		background: ${({ theme, isPunchup }) => (isPunchup ? '#fff' : theme.colors.blackGrey2)};
	}
`;

export const PlusIcon = styled.div<{ isPunchup?: boolean }>`
	svg {
		fill: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}
`;

export const DropzoneText = styled.div<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	font-size: 14px;
	text-align: center;
	margin-top: 8px;
`;

export const BrowseLink = styled.span<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.punchupOrange : theme.colors.greenBlue)};
	margin-left: 4px;
	text-decoration: underline;
	cursor: pointer;
`;

export const AddLink = styled.div<{ isPunchup?: boolean }>`
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.punchupOrange : theme.colors.greenBlue)};
	font-size: 12px;
	margin-top: 4px;
	cursor: pointer;
	text-decoration: underline;
`;

export const ErrorText = styled.div`
	color: ${({ theme }) => theme.colors.red};
	font-size: 12px;
	margin-top: 8px;
`;
